import {
  ModeratorRoutesPrivileges,
  useHasPrivilege
} from "modules/common";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "ui";

interface ShowAuditHistoryButtonProps {
  entityType: string;
  entityId?: string | null;
  variant?: "primary" | "default" | "additional" | "dashed";
  className?: string;
}

const ShowAuditHistoryButton = ({
  entityType,
  entityId,
  variant = "default",
  className
}: ShowAuditHistoryButtonProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewActivityLog = useHasPrivilege(
    ModeratorRoutesPrivileges.ActivityLog
  );

  // The button navigates into the Activity Log — hide it for admins who cannot
  // open that section, or they would just land on /no-access.
  if (!canViewActivityLog || !entityId) {
    return null;
  }

  return (
    <Button
      variant={variant}
      className={className}
      onClick={() =>
        navigate(
          `/activity-log?entityType=${entityType}&entityId=${entityId}`
        )
      }
    >
      {t("Show audit history")}
    </Button>
  );
};

export default ShowAuditHistoryButton;
